import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'

import Home24News from './Home24News.vue'
registerVueComponentAndAngularBindings('home24:news', 'home24News', Home24News);